import isUndefined from 'lodash/isUndefined';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import PauseSmallIcon from '../../../../../static/icons/ic_pause_small_24.svg';
import PlaySmallIcon from '../../../../../static/icons/ic_play_small_24.svg';
import { messages as accessMessages } from '../../../../constants/AccessibilityConstants';
import { handlerNoPropagate } from '../../../../lib/EventUtils';
import { createBEM } from '../../../../lib/utils/css';
import Icon from '../../../Icon/Icon';
import { RowItemButtonType } from '../constants';

import './RowItemPlayPauseButton.scss';

const RowItemButton = React.memo(props => {
  const { buttonType, isVisible, isRowSmall, isLarge, useDarkTheme, useLightTheme, isImgCircle } =
    props;

  if (props.playButtonOnclick && !props.onlyShowRightColPlay) {
    const visible = isUndefined(isVisible) ? props.isInteractive : isVisible;

    const message =
      buttonType === RowItemButtonType.PLAY
        ? accessMessages.playSourceName
        : accessMessages.pauseSourceName;

    let IconPlay;
    let IconPause;
    let buttonFunc = null;

    if (buttonType === RowItemButtonType.PLAY) {
      IconPlay = PlaySmallIcon;
      buttonFunc = handlerNoPropagate(props.playButtonOnclick);
    } else if (buttonType === RowItemButtonType.PAUSE && props.pauseButtonOnclick) {
      IconPause = PauseSmallIcon;
      buttonFunc = handlerNoPropagate(props.pauseButtonOnclick);
    }

    const icon =
      buttonType === RowItemButtonType.PLAY ? (
        <Icon className='iconLeftColButtonPlay iconLeftColButtonFill' glyph={IconPlay} />
      ) : (
        <Icon className='iconLeftColButtonPause iconLeftColButtonFill' glyph={IconPause} />
      );

    const classes = createBEM('RowItemPlayPauseButton', {
      disabled: props.isDisabled,
      hidden: !visible,
      small: isRowSmall,
      large: isLarge,
      dark: useDarkTheme,
      light: useLightTheme,
      circle: isImgCircle,
    });

    return (
      <button
        type='button'
        className={classes}
        aria-disabled={props.isDisabled}
        onClick={buttonFunc}
        data-qa={props.qaLeftColButton}
      >
        {icon}
        <span className='a11y--hideOnParentFocus visuallyHidden'>
          <FormattedMessage {...message} values={{ sourceName: props.mainText }} />
        </span>
      </button>
    );
  }

  return '';
});

RowItemButton.propTypes = {
  buttonType: PropTypes.oneOf([RowItemButtonType.PAUSE, RowItemButtonType.PLAY]),
  isDisabled: PropTypes.bool,
  isInteractive: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool,
  isLarge: PropTypes.bool,
  isRowSmall: PropTypes.bool,
  useDarkTheme: PropTypes.bool,
  useLightTheme: PropTypes.bool,
  isImgCircle: PropTypes.bool,
  mainText: PropTypes.string,
  onlyShowRightColPlay: PropTypes.bool,
  playButtonOnclick: PropTypes.func,
  pauseButtonOnclick: PropTypes.func,
  qaLeftColButton: PropTypes.string,
};

export default RowItemButton;
